/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { blockTower } from '../fn/admin-towers-api/block-tower';
import { BlockTower$Params } from '../fn/admin-towers-api/block-tower';
import { closeBox2 } from '../fn/admin-towers-api/close-box-2';
import { CloseBox2$Params } from '../fn/admin-towers-api/close-box-2';
import { createTower } from '../fn/admin-towers-api/create-tower';
import { CreateTower$Params } from '../fn/admin-towers-api/create-tower';
import { deleteTower } from '../fn/admin-towers-api/delete-tower';
import { DeleteTower$Params } from '../fn/admin-towers-api/delete-tower';
import { forceRequestStatus } from '../fn/admin-towers-api/force-request-status';
import { ForceRequestStatus$Params } from '../fn/admin-towers-api/force-request-status';
import { getAllTowers } from '../fn/admin-towers-api/get-all-towers';
import { GetAllTowers$Params } from '../fn/admin-towers-api/get-all-towers';
import { getTower } from '../fn/admin-towers-api/get-tower';
import { GetTower$Params } from '../fn/admin-towers-api/get-tower';
import { getTowerBox } from '../fn/admin-towers-api/get-tower-box';
import { GetTowerBox$Params } from '../fn/admin-towers-api/get-tower-box';
import { getTowerCurrentUsers } from '../fn/admin-towers-api/get-tower-current-users';
import { GetTowerCurrentUsers$Params } from '../fn/admin-towers-api/get-tower-current-users';
import { getTowerStatuses } from '../fn/admin-towers-api/get-tower-statuses';
import { GetTowerStatuses$Params } from '../fn/admin-towers-api/get-tower-statuses';
import { getWidgetTowers } from '../fn/admin-towers-api/get-widget-towers';
import { GetWidgetTowers$Params } from '../fn/admin-towers-api/get-widget-towers';
import { getWidgetTowersMonitor } from '../fn/admin-towers-api/get-widget-towers-monitor';
import { GetWidgetTowersMonitor$Params } from '../fn/admin-towers-api/get-widget-towers-monitor';
import { getWidgetTowerUsage } from '../fn/admin-towers-api/get-widget-tower-usage';
import { GetWidgetTowerUsage$Params } from '../fn/admin-towers-api/get-widget-tower-usage';
import { openBox2 } from '../fn/admin-towers-api/open-box-2';
import { OpenBox2$Params } from '../fn/admin-towers-api/open-box-2';
import { PageDtoTowerTowerDto } from '../models/page-dto-tower-tower-dto';
import { resetTower } from '../fn/admin-towers-api/reset-tower';
import { ResetTower$Params } from '../fn/admin-towers-api/reset-tower';
import { SimpleList } from '../models/simple-list';
import { TowerBoxDto } from '../models/tower-box-dto';
import { TowerDto } from '../models/tower-dto';
import { TowerMonitorDto } from '../models/tower-monitor-dto';
import { TowerUsageDto } from '../models/tower-usage-dto';
import { unblockTower } from '../fn/admin-towers-api/unblock-tower';
import { UnblockTower$Params } from '../fn/admin-towers-api/unblock-tower';
import { updateTower } from '../fn/admin-towers-api/update-tower';
import { UpdateTower$Params } from '../fn/admin-towers-api/update-tower';
import { updateTowerBox } from '../fn/admin-towers-api/update-tower-box';
import { UpdateTowerBox$Params } from '../fn/admin-towers-api/update-tower-box';
import { UserRefDto } from '../models/user-ref-dto';

@Injectable({ providedIn: 'root' })
export class AdminTowersApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTower()` */
  static readonly GetTowerPath = '/api/admin/towers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTower()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTower$Response(params: GetTower$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerDto>> {
    return getTower(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTower$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTower(params: GetTower$Params, context?: HttpContext): Observable<TowerDto> {
    return this.getTower$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerDto>): TowerDto => r.body)
    );
  }

  /** Path part for operation `updateTower()` */
  static readonly UpdateTowerPath = '/api/admin/towers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTower()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTower$Response(params: UpdateTower$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerDto>> {
    return updateTower(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTower$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTower(params: UpdateTower$Params, context?: HttpContext): Observable<TowerDto> {
    return this.updateTower$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerDto>): TowerDto => r.body)
    );
  }

  /** Path part for operation `deleteTower()` */
  static readonly DeleteTowerPath = '/api/admin/towers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTower()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTower$Response(params: DeleteTower$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTower(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTower$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTower(params: DeleteTower$Params, context?: HttpContext): Observable<void> {
    return this.deleteTower$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTowerBox()` */
  static readonly GetTowerBoxPath = '/api/admin/towerboxes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTowerBox()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerBox$Response(params: GetTowerBox$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerBoxDto>> {
    return getTowerBox(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTowerBox$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerBox(params: GetTowerBox$Params, context?: HttpContext): Observable<TowerBoxDto> {
    return this.getTowerBox$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerBoxDto>): TowerBoxDto => r.body)
    );
  }

  /** Path part for operation `updateTowerBox()` */
  static readonly UpdateTowerBoxPath = '/api/admin/towerboxes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTowerBox()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTowerBox$Response(params: UpdateTowerBox$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerBoxDto>> {
    return updateTowerBox(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTowerBox$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTowerBox(params: UpdateTowerBox$Params, context?: HttpContext): Observable<TowerBoxDto> {
    return this.updateTowerBox$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerBoxDto>): TowerBoxDto => r.body)
    );
  }

  /** Path part for operation `getAllTowers()` */
  static readonly GetAllTowersPath = '/api/admin/towers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTowers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTowers$Response(params?: GetAllTowers$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoTowerTowerDto>> {
    return getAllTowers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTowers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTowers(params?: GetAllTowers$Params, context?: HttpContext): Observable<PageDtoTowerTowerDto> {
    return this.getAllTowers$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoTowerTowerDto>): PageDtoTowerTowerDto => r.body)
    );
  }

  /** Path part for operation `createTower()` */
  static readonly CreateTowerPath = '/api/admin/towers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTower()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTower$Response(params: CreateTower$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerDto>> {
    return createTower(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTower$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTower(params: CreateTower$Params, context?: HttpContext): Observable<TowerDto> {
    return this.createTower$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerDto>): TowerDto => r.body)
    );
  }

  /** Path part for operation `unblockTower()` */
  static readonly UnblockTowerPath = '/api/admin/towers/{id}/unblock';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unblockTower()` instead.
   *
   * This method doesn't expect any request body.
   */
  unblockTower$Response(params: UnblockTower$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return unblockTower(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unblockTower$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unblockTower(params: UnblockTower$Params, context?: HttpContext): Observable<void> {
    return this.unblockTower$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `forceRequestStatus()` */
  static readonly ForceRequestStatusPath = '/api/admin/towers/{id}/status/request';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forceRequestStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  forceRequestStatus$Response(params: ForceRequestStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return forceRequestStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `forceRequestStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  forceRequestStatus(params: ForceRequestStatus$Params, context?: HttpContext): Observable<void> {
    return this.forceRequestStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `resetTower()` */
  static readonly ResetTowerPath = '/api/admin/towers/{id}/reset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetTower()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetTower$Response(params: ResetTower$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return resetTower(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetTower$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetTower(params: ResetTower$Params, context?: HttpContext): Observable<void> {
    return this.resetTower$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `blockTower()` */
  static readonly BlockTowerPath = '/api/admin/towers/{id}/block';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `blockTower()` instead.
   *
   * This method doesn't expect any request body.
   */
  blockTower$Response(params: BlockTower$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return blockTower(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `blockTower$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  blockTower(params: BlockTower$Params, context?: HttpContext): Observable<void> {
    return this.blockTower$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `openBox2()` */
  static readonly OpenBox2Path = '/api/admin/towerboxes/{id}/open';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `openBox2()` instead.
   *
   * This method doesn't expect any request body.
   */
  openBox2$Response(params: OpenBox2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return openBox2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `openBox2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  openBox2(params: OpenBox2$Params, context?: HttpContext): Observable<void> {
    return this.openBox2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `closeBox2()` */
  static readonly CloseBox2Path = '/api/admin/towerboxes/{id}/close';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `closeBox2()` instead.
   *
   * This method doesn't expect any request body.
   */
  closeBox2$Response(params: CloseBox2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return closeBox2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `closeBox2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  closeBox2(params: CloseBox2$Params, context?: HttpContext): Observable<void> {
    return this.closeBox2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTowerCurrentUsers()` */
  static readonly GetTowerCurrentUsersPath = '/api/admin/towers/{id}/currentUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTowerCurrentUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerCurrentUsers$Response(params: GetTowerCurrentUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserRefDto>>> {
    return getTowerCurrentUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTowerCurrentUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerCurrentUsers(params: GetTowerCurrentUsers$Params, context?: HttpContext): Observable<Array<UserRefDto>> {
    return this.getTowerCurrentUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserRefDto>>): Array<UserRefDto> => r.body)
    );
  }

  /** Path part for operation `getWidgetTowers()` */
  static readonly GetWidgetTowersPath = '/api/admin/towers/widget';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWidgetTowers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWidgetTowers$Response(params?: GetWidgetTowers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TowerDto>>> {
    return getWidgetTowers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWidgetTowers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWidgetTowers(params?: GetWidgetTowers$Params, context?: HttpContext): Observable<Array<TowerDto>> {
    return this.getWidgetTowers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TowerDto>>): Array<TowerDto> => r.body)
    );
  }

  /** Path part for operation `getWidgetTowerUsage()` */
  static readonly GetWidgetTowerUsagePath = '/api/admin/towers/widget/usage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWidgetTowerUsage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWidgetTowerUsage$Response(params: GetWidgetTowerUsage$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TowerUsageDto>>> {
    return getWidgetTowerUsage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWidgetTowerUsage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWidgetTowerUsage(params: GetWidgetTowerUsage$Params, context?: HttpContext): Observable<Array<TowerUsageDto>> {
    return this.getWidgetTowerUsage$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TowerUsageDto>>): Array<TowerUsageDto> => r.body)
    );
  }

  /** Path part for operation `getWidgetTowersMonitor()` */
  static readonly GetWidgetTowersMonitorPath = '/api/admin/towers/widget/monitor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWidgetTowersMonitor()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWidgetTowersMonitor$Response(params?: GetWidgetTowersMonitor$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TowerMonitorDto>>> {
    return getWidgetTowersMonitor(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWidgetTowersMonitor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWidgetTowersMonitor(params?: GetWidgetTowersMonitor$Params, context?: HttpContext): Observable<Array<TowerMonitorDto>> {
    return this.getWidgetTowersMonitor$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TowerMonitorDto>>): Array<TowerMonitorDto> => r.body)
    );
  }

  /** Path part for operation `getTowerStatuses()` */
  static readonly GetTowerStatusesPath = '/api/admin/towers/statuses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTowerStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerStatuses$Response(params?: GetTowerStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleList>> {
    return getTowerStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTowerStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerStatuses(params?: GetTowerStatuses$Params, context?: HttpContext): Observable<SimpleList> {
    return this.getTowerStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleList>): SimpleList => r.body)
    );
  }

}
